// Settings Page
function initsettings() {
    const page = document.getElementById('page-settings');
    
    // Get current settings from localStorage
    const currentTheme = localStorage.getItem('polyglot-theme') || 'coral-grey';
    const currentMode = localStorage.getItem('polyglot-mode') || 'light';
    const currentLanguage = localStorage.getItem('polyglot-user-language') || 'eng';
    const currentTtsMode = localStorage.getItem('polyglot-tts-mode') || 'vits';
    
    // Get user info from signed-in user (Google account only)
    let currentName = '';
    let userEmail = '';
    let userImageUrl = '';

    console.log('Settings page: checking for user info...');
    console.log('window.googleAuthService:', !!window.googleAuthService);
    console.log('window.userAuthComponent:', !!window.userAuthComponent);

    // Get user info from Google auth service
    if (window.googleAuthService && window.googleAuthService.isSignedIn()) {
        console.log('Getting user info from googleAuthService');
        const user = window.googleAuthService.getUserInfo();
        console.log('User info:', user);
        if (user) {
            currentName = user.name || '';
            userEmail = user.email || '';
            userImageUrl = user.imageUrl || '';
        }
    } else if (window.userAuthComponent && window.userAuthComponent.getCurrentUser()) {
        console.log('Getting user info from userAuthComponent');
        const user = window.userAuthComponent.getCurrentUser();
        console.log('User info:', user);
        if (user) {
            currentName = user.name || '';
            userEmail = user.email || '';
            userImageUrl = user.imageUrl || '';
        }
    } else {
        console.log('No user authentication found or user not signed in');
    }

    // Fall back to localStorage name if Google auth didn't provide one
    if (!currentName) {
        currentName = localStorage.getItem('polyglot-user-name') || '';
    }
    
    const isGoogleSignedIn = !!(userEmail);
    
    console.log('Final user info - Name:', currentName, 'Email:', userEmail, 'Image:', userImageUrl);

    // Get backend configuration info
    const backendInfo = window.configService ? window.configService.getStatusInfo() : {
        backend: 'unknown',
        name: 'Unknown',
        apiUrl: '',
        isLocal: false
    };

    page.innerHTML = `
        <header class="p-4 flex items-center space-x-4 backdrop-blur-md z-20 shrink-0 shadow-md" style="background-color: var(--surface-current); border-bottom: 1px solid var(--border-current);">
            <button id="settings-back-button" class="p-2 rounded-full hover:bg-opacity-20 transition-colors app-button-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                </svg>
            </button>
            <h1 class="text-xl font-semibold">Settings</h1>
        </header>

        <main class="flex-grow p-4 md:p-6 overflow-y-auto">
            <div class="max-w-md mx-auto space-y-6">
                <!-- Personal Information -->
                <section class="app-element p-4">
                    <h2 class="text-lg font-semibold mb-4" style="color: var(--text-current);">Personal Information</h2>
                    
                    <!-- User Profile -->
                    ${userEmail ? `
                    <div class="flex items-center space-x-4 mb-6 p-4 rounded-lg" style="background-color: var(--bg-secondary-current);">
                        ${userImageUrl ? `<img src="${userImageUrl}" alt="Profile" class="w-16 h-16 rounded-full border-2" style="border-color: var(--border-current);">` : ''}
                        <div>
                            <p class="font-medium" style="color: var(--text-current);">${userEmail}</p>
                            <p class="text-sm" style="color: var(--muted-text-current);">Signed in with Google</p>
                            <button id="settings-sign-out-btn" class="text-sm text-red-600 hover:text-red-700 mt-1">Sign out</button>
                        </div>
                    </div>
                    ` : ''}
                    
                    <div class="space-y-4">
                        ${isGoogleSignedIn ? `
                        <div>
                            <label class="block text-sm font-medium mb-1" style="color: var(--muted-text-current);">Your Name</label>
                            <p class="text-base font-medium" style="color: var(--text-current);">${currentName}</p>
                            <p class="text-xs mt-1" style="color: var(--muted-text-current);">From your Google account</p>
                        </div>
                        ` : `
                        <div>
                            <label for="settings-user-name" class="block text-sm font-medium mb-1" style="color: var(--muted-text-current);">Your Name</label>
                            <input type="text" id="settings-user-name" class="form-input w-full" placeholder="Enter your name" value="${currentName}">
                            <p class="text-xs mt-1" style="color: var(--muted-text-current);">Shown to others in rooms</p>
                        </div>
                        `}

                        <div>
                            <label for="settings-user-language" class="block text-sm font-medium mb-1" style="color: var(--muted-text-current);">Preferred Language</label>
                            <select id="settings-user-language" class="language-select form-input w-full">
                                <option value="eng" ${currentLanguage === 'eng' ? 'selected' : ''}>English (eng)</option>
                                <option value="swa" ${currentLanguage === 'swa' ? 'selected' : ''}>Swahili (swa)</option>
                                <option value="kik" ${currentLanguage === 'kik' ? 'selected' : ''}>Kikuyu (kik)</option>
                                <option value="kam" ${currentLanguage === 'kam' ? 'selected' : ''}>Kamba (kam)</option>
                                <option value="mer" ${currentLanguage === 'mer' ? 'selected' : ''}>Kimeru (mer)</option>
                                <option value="luo" ${currentLanguage === 'luo' ? 'selected' : ''}>Luo (luo)</option>
                                <option value="som" ${currentLanguage === 'som' ? 'selected' : ''}>Somali (som)</option>
                            </select>
                        </div>
                    </div>
                </section>

                <!-- Voice & Audio -->
                <section class="app-element p-4">
                    <h2 class="text-lg font-semibold mb-4" style="color: var(--text-current);">Voice & Audio</h2>
                    <div class="space-y-4">
                        <div>
                            <label for="settings-tts-mode" class="block text-sm font-medium mb-1" style="color: var(--muted-text-current);">Text-to-Speech Engine</label>
                            <select id="settings-tts-mode" class="form-input w-full">
                                <option value="vits" ${currentTtsMode === 'vits' ? 'selected' : ''}>VITS (Default — Fast, Lightweight)</option>
                                <option value="chatterbox_known" ${currentTtsMode === 'chatterbox_known' ? 'selected' : ''}>Chatterbox — Known Speaker (Higher Quality)</option>
                                <option value="chatterbox_clone" ${currentTtsMode === 'chatterbox_clone' ? 'selected' : ''}>Chatterbox — Voice Cloning (Uses Your Voice)</option>
                            </select>
                            <p class="text-xs mt-1" style="color: var(--muted-text-current);">VITS is fast and runs on CPU. Chatterbox provides higher quality but requires GPU on the server.</p>
                        </div>
                    </div>
                </section>

                <!-- App Installation -->
                <section id="settings-install-section" class="app-element p-4">
                    <h2 class="text-lg font-semibold mb-4" style="color: var(--text-current);">App Installation</h2>
                    <div id="settings-install-content"></div>
                </section>

                <!-- Backend Server (only show on localhost or *.tafiti.dev) -->
                ${window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.endsWith('.tafiti.dev') ? `
                <section class="app-element p-4">
                    <h2 class="text-lg font-semibold mb-4" style="color: var(--text-current);">Backend Server</h2>

                    <div class="space-y-4">
                        <div>
                            <label class="block text-sm font-medium mb-2" style="color: var(--muted-text-current);">Current Backend</label>
                            <div class="p-3 rounded-lg" style="background-color: var(--bg-secondary-current); border: 1px solid var(--border-current);">
                                <p class="font-medium mb-1" style="color: var(--text-current);">${backendInfo.name}</p>
                                <p class="text-xs" style="color: var(--muted-text-current);">${backendInfo.apiUrl}</p>
                            </div>
                        </div>

                        <div>
                            <label class="block text-sm font-medium mb-2" style="color: var(--muted-text-current);">Switch Backend</label>
                            <div class="grid grid-cols-2 gap-2">
                                <button id="settings-backend-local" class="p-3 rounded-lg border transition-colors">
                                    <div class="flex items-center justify-center space-x-2">
                                        <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25" />
                                        </svg>
                                        <span class="text-sm">Local</span>
                                    </div>
                                </button>
                                <button id="settings-backend-local-test" class="p-3 rounded-lg border transition-colors">
                                    <div class="flex items-center justify-center space-x-2">
                                        <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25" />
                                        </svg>
                                        <span class="text-sm">Local (test)</span>
                                    </div>
                                </button>
                                <button id="settings-backend-primary" class="p-3 rounded-lg border transition-colors">
                                    <div class="flex items-center justify-center space-x-2">
                                        <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 001.332-7.257 3 3 0 00-3.758-3.848 5.25 5.25 0 00-10.233 2.33A4.502 4.502 0 002.25 15z" />
                                        </svg>
                                        <span class="text-sm">Primary</span>
                                    </div>
                                </button>
                                <button id="settings-backend-secondary" class="p-3 rounded-lg border transition-colors">
                                    <div class="flex items-center justify-center space-x-2">
                                        <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 001.332-7.257 3 3 0 00-3.758-3.848 5.25 5.25 0 00-10.233 2.33A4.502 4.502 0 002.25 15z" />
                                        </svg>
                                        <span class="text-sm">Secondary</span>
                                    </div>
                                </button>
                            </div>
                            <p class="text-xs mt-2" style="color: var(--muted-text-current);">Switch between local development server and cloud backend for testing.</p>
                        </div>
                    </div>
                </section>
                ` : ''}

                <!-- Appearance -->
                <section class="app-element p-4">
                    <h2 class="text-lg font-semibold mb-4" style="color: var(--text-current);">Appearance</h2>
                    
                    <div class="space-y-4">
                        <div hidden>
                            <label for="settings-theme-selector" class="block text-sm font-medium mb-1" style="color: var(--muted-text-current);">Theme</label>
                            <select id="settings-theme-selector" class="form-input w-full">
                                <option value="coral-grey" ${currentTheme === 'coral-grey' ? 'selected' : ''}>Coral Grey</option>
                                <option value="azure-mist" ${currentTheme === 'azure-mist' ? 'selected' : ''}>Azure Mist</option>
                                <option value="emerald-focus" ${currentTheme === 'emerald-focus' ? 'selected' : ''}>Emerald Focus</option>
                            </select>
                        </div>                        
                        <div>
                            <label class="block text-sm font-medium mb-2" style="color: var(--muted-text-current);">Color Mode</label>
                            <div class="flex space-x-2">
                                <button id="settings-light-mode" class="flex-1 p-3 rounded-lg border transition-colors">
                                    <div class="flex items-center justify-center space-x-2">
                                        <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" />
                                        </svg>
                                        <span>Light</span>
                                    </div>
                                </button>
                                <button id="settings-dark-mode" class="flex-1 p-3 rounded-lg border transition-colors">
                                    <div class="flex items-center justify-center space-x-2">
                                        <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z" />
                                        </svg>
                                        <span>Dark</span>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    `;

    // Settings logic
    const languageSelect = document.getElementById('settings-user-language');
    const themeSelect = document.getElementById('settings-theme-selector');
    const lightModeButton = document.getElementById('settings-light-mode');
    const darkModeButton = document.getElementById('settings-dark-mode');
    const localBackendButton = document.getElementById('settings-backend-local');
    const localTestBackendButton = document.getElementById('settings-backend-local-test');
    const secondaryBackendButton = document.getElementById('settings-backend-secondary');
    const primaryBackendButton = document.getElementById('settings-backend-primary');

    let selectedMode = currentMode;

    function updateModeButtons() {
        lightModeButton.style.borderColor = selectedMode === 'light' ? 'var(--accent-current)' : 'var(--border-current)';
        lightModeButton.style.backgroundColor = selectedMode === 'light' ? 'rgba(255, 255, 255, 0.1)' : '';
        darkModeButton.style.borderColor = selectedMode === 'dark' ? 'var(--accent-current)' : 'var(--border-current)';
        darkModeButton.style.backgroundColor = selectedMode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : '';
    }

    function updateBackendButtons() {
        if (!localBackendButton || !secondaryBackendButton || !localTestBackendButton || !primaryBackendButton) {
            console.log('[Settings] updateBackendButtons: Some buttons not found');
            return;
        }

        // Get the current backend type from localStorage or configService
        const currentBackend = window.configService ? window.configService.backendType : localStorage.getItem('polyglot_backend') || 'local';
        console.log('[Settings] updateBackendButtons: currentBackend =', currentBackend);

        // Reset all buttons to default style
        const allButtons = [localBackendButton, localTestBackendButton, secondaryBackendButton, primaryBackendButton];
        allButtons.forEach(btn => {
            btn.style.borderColor = 'var(--border-current)';
            btn.style.backgroundColor = '';
        });

        // Highlight the active button
        let activeButton = null;
        switch(currentBackend) {
            case 'local':        activeButton = localBackendButton; break;
            case 'local_test':   activeButton = localTestBackendButton; break;
            case 'secondary-endpoint': activeButton = secondaryBackendButton; break;
            case 'primary-endpoint':   activeButton = primaryBackendButton; break;
        }

        if (activeButton) {
            activeButton.style.borderColor = 'var(--accent-current)';
            activeButton.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
        }
    }

    // Event handlers with auto-save
    lightModeButton.addEventListener('click', () => {
        selectedMode = 'light';
        updateModeButtons();
        applyTheme(themeSelect.value, selectedMode);
        localStorage.setItem('polyglot-mode', selectedMode);
    });

    darkModeButton.addEventListener('click', () => {
        selectedMode = 'dark';
        updateModeButtons();
        applyTheme(themeSelect.value, selectedMode);
        localStorage.setItem('polyglot-mode', selectedMode);
    });

    themeSelect.addEventListener('change', () => {
        applyTheme(themeSelect.value, selectedMode);
        localStorage.setItem('polyglot-theme', themeSelect.value);
    });

    languageSelect.addEventListener('change', () => {
        localStorage.setItem('polyglot-user-language', languageSelect.value);
    });

    // User name handler (only present when not signed in with Google)
    const userNameInput = document.getElementById('settings-user-name');
    if (userNameInput) {
        userNameInput.addEventListener('change', () => {
            const name = userNameInput.value.trim();
            if (name) {
                localStorage.setItem('polyglot-user-name', name);
            } else {
                localStorage.removeItem('polyglot-user-name');
            }
        });
    }

    // TTS mode handler
    const ttsModeSelect = document.getElementById('settings-tts-mode');
    if (ttsModeSelect) {
        ttsModeSelect.addEventListener('change', () => {
            localStorage.setItem('polyglot-tts-mode', ttsModeSelect.value);
            console.log('TTS mode changed to:', ttsModeSelect.value);
        });
    }

    // Backend switching handlers (only attach if buttons exist)
    if (localBackendButton) {
        localBackendButton.addEventListener('click', () => {
            if (window.configService) {
                const switched = window.configService.switchBackend('local');
                if (switched) {
                    console.log('Switched to local backend');
                    // Reload the page to apply the new backend
                    window.location.reload();
                }
            }
        });
    }

    if (localTestBackendButton) {
        localTestBackendButton.addEventListener('click', () => {
            if (window.configService) {
                const switched = window.configService.switchBackend('local_test');
                if (switched) {
                    console.log('Switched to local (test) backend');
                    // Reload the page to apply the new backend
                    window.location.reload();
                }
            }
        });
    }

    if (secondaryBackendButton) {
        secondaryBackendButton.addEventListener('click', () => {
            if (window.configService) {
                const switched = window.configService.switchBackend('secondary-endpoint');
                if (switched) {
                    window.location.reload();
                }
            }
        });
    }

    if (primaryBackendButton) {
        primaryBackendButton.addEventListener('click', () => {
            if (window.configService) {
                const switched = window.configService.switchBackend('primary-endpoint');
                if (switched) {
                    window.location.reload();
                }
            }
        });
    }
    // Initialize other components

    document.getElementById('settings-back-button').addEventListener('click', () => {
        showPage('page-main-menu');
    });

    // Add sign out handler if the button exists
    const signOutBtn = document.getElementById('settings-sign-out-btn');
    if (signOutBtn) {
        signOutBtn.addEventListener('click', async () => {
            try {
                if (window.googleAuthService) {
                    await window.googleAuthService.signOut();
                    window.location.reload(); // Reload to restart auth flow
                } else if (window.userAuthComponent) {
                    await window.userAuthComponent.signOut();
                }
            } catch (error) {
                console.error('Sign out failed:', error);
            }
        });
    }

    updateModeButtons();
    updateBackendButtons();
    
    // Set up PWA installation section
    setupInstallSection();
}

// PWA Installation section setup
function setupInstallSection() {
    const installSection = document.getElementById('settings-install-section');
    const installContent = document.getElementById('settings-install-content');
    
    if (!installSection || !installContent) {
        console.error('Install section elements not found');
        return;
    }
    
    // Check if PWA is already installed
    const isInstalled = isPWAInstalled();
    
    if (isInstalled) {
        // Hide the entire install section if already installed
        installSection.style.display = 'none';
    } else {
        // Show install option
        installContent.innerHTML = `
            <div>
                <h3 class="text-base font-medium mb-2" style="color: var(--text-current);">Install Polyglot App</h3>
                <p class="text-sm mb-4" style="color: var(--muted-text-current);">Install Polyglot for faster access, offline support, and a native app experience.</p>
                <button id="settings-install-button" class="app-button app-button-primary px-4 py-2 text-sm flex items-center">
                    <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                    </svg>
                    <span>Install Now</span>
                </button>
            </div>
        `;
        
        // Set up event handlers
        const installButton = document.getElementById('settings-install-button');
        
        if (installButton) {
            installButton.addEventListener('click', async () => {
                console.log('Install button clicked from settings');
                
                // Try using the deferred prompt if available
                if (window.deferredPrompt) {
                    try {
                        installButton.disabled = true;
                        installButton.className = 'app-button app-button-primary px-4 py-2 text-sm flex items-center';
                        installButton.innerHTML = `
                            <svg class="w-4 h-4 mr-2 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                            </svg>
                            <span>Installing...</span>
                        `;
                        
                        // Show the install prompt
                        window.deferredPrompt.prompt();
                        
                        // Wait for the user's response
                        const choiceResult = await window.deferredPrompt.userChoice;
                        
                        if (choiceResult.outcome === 'accepted') {
                            console.log('User accepted the install prompt');
                            installButton.innerHTML = `
                                <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                </svg>
                                Installed!
                            `;
                            
                            // Hide the install section after successful installation
                            setTimeout(() => {
                                installSection.style.display = 'none';
                            }, 2000);
                        } else {
                            console.log('User dismissed the install prompt');
                            installButton.disabled = false;
                            installButton.className = 'app-button app-button-primary px-4 py-2 text-sm flex items-center';
                            installButton.innerHTML = `
                                <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                                </svg>
                                <span>Install Now</span>
                            `;
                        }
                        
                        // Clear the prompt
                        window.deferredPrompt = null;
                    } catch (error) {
                        console.error('Installation failed:', error);
                        installButton.disabled = false;
                        installButton.className = 'app-button app-button-primary px-4 py-2 text-sm flex items-center';
                        installButton.innerHTML = `
                            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                            </svg>
                            <span>Install Now</span>
                        `;
                    }
                } else {
                    // No install prompt available - show instructions
                    console.log('No install prompt available');

                    const instructions = `
                        <div class="p-4 rounded-lg" style="background-color: var(--surface-current); border: 1px solid var(--border-current);">
                            <h4 class="font-medium mb-2" style="color: var(--text-current);">Manual Installation</h4>
                            <p class="text-sm mb-2" style="color: var(--muted-text-current);">To install Polyglot:</p>
                            <ul class="text-sm list-disc list-inside space-y-1" style="color: var(--muted-text-current);">
                                <li>Chrome/Edge: Click the install icon in the address bar</li>
                                <li>Safari: Tap Share → Add to Home Screen</li>
                                <li>Firefox: Look for "Install" in the menu</li>
                            </ul>
                        </div>
                    `;

                    // Replace button with instructions
                    installButton.outerHTML = instructions;
                }
            });
        }
    }
}

// Helper function to detect if PWA is installed (reused from install.js)
function isPWAInstalled() {
    // Check if running as PWA
    if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
        return true;
    }
    
    // Check if running in fullscreen mode (another PWA indicator)
    if (window.navigator.standalone === true) {
        return true;
    }
    
    // Check for PWA-specific properties
    if (document.referrer.includes('android-app://')) {
        return true;
    }
    
    return false;
}

// Expose function globally for showPage to access
window.initsettings = initsettings;
